export default {"src":"/_next/static/media/share.b5780f43.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};